import React, { useEffect, useState } from 'react'
import DataTable from 'app/components/table/DataTable'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import TrashButton from 'app/components/buttons/TrashButton'

import useStyles from '../styles'
import {
  Checkbox,
  Icon,
  Popover,
  ListItemIcon,
  ListItemText,
  MenuItem,
  IconButton,
} from '@material-ui/core'
import clsx from 'clsx'
import { useAccessControl } from 'app/auth/useAccessControl'
import { AccessType } from 'app/auth/accessControlService'
import {
  withFirstColumn,
  withAvatarColumn,
} from '../../../components/table/TableColumn'
import * as R from 'ramda'
import appConfigs from 'app/configs/appConfigs'
import moment from 'moment'
import StatusChips from '../../../components/StatusChips'
import { useChecked } from 'app/components/table/useChecked'
import { isGeneralOrExternalGroup } from 'commons/groupLogic'

const MAX_PAGINATION = 10
const DEFAULT_PAGE_SIZE = 10

const headerStyle = {
  textAlign: 'left',
  fontSize: 13,
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}

const headerStyleThree = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const cellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const cellStyleTwo = {
  color: '#c5c5c5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export default (props) => {
  const {
    state,
    setState,
    toggleDialogs,
    DETACH_SUBSCRIBERS_DIALOG,
    EXPORT_CSV_DIALOG,
    EXPORT_PDF_DIALOG,
    ALL_SUBGROUPS,
    readOnly,
    handleOpenSubscriber,
    onErrorViewSubscriber,
    setLocalState,
    isLoading,
  } = props
  const { formatMessage } = useIntl()
  const classes = useStyles()
  let dataTable = []

  const {
    state: stateTables,
    toggleSelect,
    toggleSelectAll,
    onPageChange,
    onPageSizeChange,
    setInitailDate,
  } = useChecked({ ...state, membersList: dataTable })

  const DisplayWithHideContactsLogic = ({ original, value, render }) => {
    if (original.hideContacts) {
      return (
        <Typography className={clsx('italic', classes.restrictedText)}>
          <FormattedMessage id="subscriber.label.restricted" />
        </Typography>
      )
    }

    return render
  }

  let dataSubscribers = []
  state.groupDetailsList.tags &&
    state.groupDetailsList.tags.forEach((elem) => {
      let subscribers = elem.subscribers
      if (subscribers && subscribers.length > 0) {
        subscribers.forEach((subscriber) => {
          let email = subscriber.email || formatMessage({ id: 'notProvided' })
          let fullNumber = subscriber.phoneNumber
            ? `${subscriber.countryCode} ${subscriber.phoneNumber}`
            : formatMessage({ id: 'notProvided' })
          let subscriberId = subscriber.id
          dataSubscribers[subscriberId] = {
            avatar: subscriber.avatar,
            crmInfo: subscriber.crmInfo,
            id: subscriber.id,
            firstName: subscriber.firstName,
            lastName: subscriber.lastName,
            avatarCharacters: subscriber.avatarCharacters,
            email,
            birthday: subscriber.birthday,
            phone: fullNumber,
            subgroups: subscriber.tags
              .filter((tag) => isGeneralOrExternalGroup(tag?.group?.type))
              .map((tag) => tag.name)
              .join(', '),
            subscriberId,
            groupId: elem.groupId,
            subGroupId: subscriber.tags
              .filter((tag) => isGeneralOrExternalGroup(tag?.group?.type))
              .map((tag) => tag.id),
            tags: subscriber.tags
              .filter((tag) => isGeneralOrExternalGroup(tag?.group?.type))
              .map((tag) => tag.id),
            hideContacts: subscriber.hideContacts,
            language: subscriber.parent
              ? subscriber.parent.language.languageDetails
              : '',
            lastInvitationStatus: subscriber.lastInvitationStatus,
          }
        })
      }
    })
  dataTable = dataSubscribers.filter((n) => n)

  useEffect(() => {
    setLocalState((state) => ({
      ...state,
      checkedItems: R.map((id) => parseInt(id), R.keys(dataSubscribers)),
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTable.length])

  useEffect(() => {
    setState((state) => ({
      ...state,
      selected: stateTables.selectedList.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, []),
      isSelectAll: stateTables.isSelectAll,
    }))
  }, [setState, stateTables.isSelectAll, stateTables.selectedList])

  useEffect(() => {
    if (!R.isEmpty(state.groupDetailsList)) {
      setInitailDate({
        checkedItems: [],
        membersList: dataTable,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.groupDetailsList])

  function detachAllSubscribers() {
    let subGroupId =
      state.selectedSubgroup['id'] === ALL_SUBGROUPS
        ? undefined
        : state.selectedSubgroup['id']
    toggleDialogs(DETACH_SUBSCRIBERS_DIALOG, true, {
      subscriberId: stateTables.checkedItems,
      subGroupId: subGroupId,
    })
  }

  const { isGranted } = useAccessControl([
    AccessType.SUBSCRIBER_UPDATE,
    AccessType.ADMINISTRATION,
  ])

  const { isGranted: canViewSubscriber } = useAccessControl([
    AccessType.SUBSCRIBER_VIEW,
    AccessType.ADMINISTRATION,
  ])
  const columns = [
    {
      ...withFirstColumn({
        id: 'checkbox',
        sortable: false,
        accessor: '',
        Header: (props) => {
          const [userMenu, setDeletePopover] = useState(null)

          const openDeletePopover = (event) => {
            setDeletePopover(event.currentTarget)
          }

          const closeDeletePopover = () => {
            setDeletePopover(null)
          }

          return (
            <div className="flex w-full justify-start">
              <Checkbox
                className="checkbox checkbox-select-all"
                checked={R.prop('isCheckAll', stateTables)}
                onClick={(event) => event.stopPropagation()}
                onChange={R.compose(
                  toggleSelectAll,
                  R.path(['target', 'checked']),
                )}
                color="secondary"
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
                indeterminate={R.prop('indeterminate', stateTables)}
              />
              {stateTables.checkedItems.length > 0 && (
                <div className="mt-8">
                  <IconButton
                    color="secondary"
                    className="p-0"
                    onClick={openDeletePopover}
                  >
                    <Icon>more_vert</Icon>
                  </IconButton>
                  <Popover
                    open={Boolean(userMenu)}
                    anchorEl={userMenu}
                    onClose={closeDeletePopover}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    {
                      <React.Fragment>
                        <MenuItem
                          className={classes.exportTabBtn}
                          onClick={() => {
                            toggleDialogs(EXPORT_CSV_DIALOG, true)
                          }}
                        >
                          <ListItemIcon className="min-w-40">
                            <img src="assets/images/etc/ic_csv.svg" alt="" />
                          </ListItemIcon>
                          <ListItemText
                            className="ltr:pl-0 rtl:pr-0"
                            primary={formatMessage({
                              id: 'groups.action.exportCSV.label',
                            })}
                          />
                        </MenuItem>

                        <MenuItem
                          className={classes.exportTabBtn}
                          onClick={() => {
                            toggleDialogs(EXPORT_PDF_DIALOG, true)
                          }}
                        >
                          <ListItemIcon className="min-w-40">
                            <img
                              style={{ marginLeft: 4 }}
                              src="assets/images/etc/file-pdf-solid.svg"
                              alt=""
                            />
                          </ListItemIcon>
                          <ListItemText
                            className="ltr:pl-0 rtl:pr-0"
                            primary={formatMessage({
                              id: 'groups.action.exportPDF.label',
                            })}
                          />
                        </MenuItem>

                        {isGranted && !readOnly && (
                          <MenuItem
                            className={classes.deleteTabBtn}
                            onClick={detachAllSubscribers}
                          >
                            <ListItemIcon className="min-w-40">
                              <Icon
                                className={classes.deleteIcon}
                                fontSize="default"
                              >
                                delete
                              </Icon>
                            </ListItemIcon>
                            <ListItemText
                              className="ltr:pl-0 rtl:pr-0"
                              primary={formatMessage({
                                id: 'groups.action.deleteSelected.label',
                              })}
                            />
                          </MenuItem>
                        )}
                      </React.Fragment>
                    }
                  </Popover>
                </div>
              )}
            </div>
          )
        },
        Cell: (row) => {
          return (
            <div className="flex w-full h-full justify-start content-center">
              <Checkbox
                type="checkbox"
                checked={R.includes(
                  row.value.id,
                  R.prop('checkedItems', stateTables),
                )}
                onClick={(event) => event.stopPropagation()}
                onChange={() =>
                  R.compose(toggleSelect, R.path(['value', 'id']))(row)
                }
              />
            </div>
          )
        },
        width: 96,
        style: cellStyle,
        className: clsx(
          'sticky fixBackgroundLight',
          classes.fixBackgroundLight,
        ),
        headerClassName: clsx('sticky', classes.fixBackgroundLight),
      }),
    },
    withAvatarColumn(),
    {
      Header: formatMessage({ id: 'firstName.label' }),
      accessor: 'firstName',
      id: 'firstName',
      filterable: true,
      width: 120,
    },
    {
      Header: formatMessage({ id: 'lastName.label' }),
      accessor: 'lastName',
      id: 'lastName',
      filterable: true,
      width: 120,
    },
    {
      Header: formatMessage({ id: 'subscriber.label.groups' }),
      accessor: 'subgroups',
      id: 'subgroups',
      filterable: true,
      sortable: false,
    },
    {
      Header: formatMessage({ id: 'groups.label.language' }),
      accessor: 'language',
      id: 'language',
      Cell: (props) => (props.value ? props.value['name'] : ''),
      filterable: false,
      sortable: false,
      width: 180,
    },
    {
      Header: formatMessage({ id: 'subscriber.label.dateOfBirth' }),
      accessor: 'birthday',
      id: 'birthday',
      Cell: (props) => (
        <DisplayWithHideContactsLogic
          {...props}
          render={R.compose(
            R.unless(
              R.isNil,
              R.compose((a) => a.format(appConfigs.dateFormat), moment),
            ),
            R.prop('value'),
          )(props)}
        />
      ),
      filterable: true,
      sortable: false,
      width: 130,
    },
    {
      Header: formatMessage({ id: 'group.table.th.email' }),
      accessor: 'email',
      headerStyle,
      Cell: (props) => (
        <DisplayWithHideContactsLogic {...props} render={props.value} />
      ),
      width: 160,
    },
    {
      Header: formatMessage({ id: 'phone.label' }),
      accessor: 'phone',
      headerStyle,
      Cell: (props) => (
        <DisplayWithHideContactsLogic {...props} render={props.value} />
      ),
      width: 120,
    },
    {
      accessor: 'status',
      id: 'status',
      width: 130,
      Header: formatMessage({ id: 'text.status' }),
      Cell: (props) => (
        <StatusChips status={props.original.lastInvitationStatus || 0} />
      ),
      filterable: true,
      sortable: false,
    },
    {
      id: 'trash',
      sortable: false,
      accessor: '',
      Cell: ({ original }) => {
        return (
          <div className="flex w-full justify-end">
            <TrashButton
              onClick={(event) => {
                event.stopPropagation()
                toggleDialogs(DETACH_SUBSCRIBERS_DIALOG, true, original)
              }}
            />
          </div>
        )
      },
      Header: (x) => '',
      width: 80,
      headerStyle: headerStyleThree,
      style: cellStyleTwo,
      show: isGranted && !readOnly,
    },
  ]
  const showGroupDetails = () => {
    return dataTable.length > 0 ? drawGroups() : NoDataConst()
  }

  const drawGroups = () => {
    return (
      <>
        <DataTable
          data={R.prop('membersList', stateTables)}
          columns={columns}
          total={R.length(R.prop('membersList', stateTables))}
          showPagination={
            R.length(R.prop('membersList', stateTables)) > MAX_PAGINATION
          }
          sortable={true}
          resizable={true}
          minRows={0}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          className={clsx(
            classes.table_detail,
            classes.tableWithFilters,
            classes.tableContent,
            classes.groupTable,
            classes.trHover,
          )}
          defaultPageSize={DEFAULT_PAGE_SIZE}
          getTrProps={(state, rowInfo, column) => {
            return {
              className: 'cursor-pointer',
              onClick: (e, handleOriginal) => {
                canViewSubscriber
                  ? handleOpenSubscriber(rowInfo.original.subscriberId)
                  : onErrorViewSubscriber()
              },
            }
          }}
          loading={isLoading}
        />
        <div className="w-full" />
      </>
    )
  }

  const NoDataConst = () => (
    <div
      className={clsx(
        classes.emptyContainer,
        'flex flex-col border-t-1 pt-24 pb-64',
      )}
    >
      <Typography variant="body1" className="text-center">
        {formatMessage({ id: 'group.noSubscribers.title' })}
      </Typography>
    </div>
  )
  return showGroupDetails()
}
